<template>
  <div class="Profile container">
    <div class="Navigation">
      <div class="UserInfo">
        <div
          class="Avatar"
          :style="backgroundAvatarStyle"
        >
          <span v-if="companyProject?.avatar_url == null" class="AvatarName">{{
            getAvatarSymbols
          }}</span>
        </div>
        <span class="ProfileName">{{ company_name }}</span>
      </div>

      <div class="Nav">
        <component
          v-for="_item in menus"
          :key="`menu-${_item.name}`"
          :class="{
            NavItem: true,
            Active: menu === _item.name,
          }"
          :is="_item.name === 'Профиль' ? 'RouterLink' : 'div'"
          v-bind="
            _item.name === 'Профиль' ? { to: '/org/education-center-edit' } : {}
          "
          @click="menu = _item.name"
        >
          <span class="NavItemText">{{ $t(_item.translate) }}</span>

          <div
            v-if="
              moderation.state !== 'empty' &&
                moderation.state !== 'active' &&
                _item.name === 'Профиль'
            "
            :class="{
              msg: true,
              wait: moderation.state === 'waiting',
              warn: moderation.state === 'fail',
            }"
          >
            <span>
              {{
                $t(
                  moderation.state === "waiting"
                    ? "pages.profile.menus.state.wait"
                    : "pages.profile.menus.state.warn"
                )
              }}
            </span>

            <img
              v-if="moderation.state === 'fail'"
              src="./../../assets/img/ReDesign/interface_icons/moderation_fail_16px.svg"
              alt=""
            />

            <div class="DeclineMSG">
              <span>{{ moderation.msg }}</span>
            </div>
          </div>
        </component>
      </div>
    </div>

    <div v-if="!isloading" class="ViewArea">
      <template v-if="menu === 'Главная'">
        <div class="InfoBlock">
          <span class="Welcome"
            >{{ $t("pages.profile.main.welcome") }}, {{ company_name }}!</span
          >
          <span class="Desc">{{ $t("pages.profile.main.desc") }}</span>
        </div>

        <template v-if="moderation.state === 'active' && courses.length >= 1">
          <div class="QuickActions">
            <span class="QATitle">{{
              $t("pages.profile.main.quick_access.title")
            }}</span>
            <div class="QAButtons">
              <router-link class="qabtn bg" to="/org/course-add">
                <img
                  src="./../../assets/img/ReDesign/interface_icons/Add_round_light.svg"
                  alt=""
                />
                <span>{{
                  $t("pages.profile.main.quick_access.buttons.create_course")
                }}</span>
              </router-link>

              <div class="qabtn border" @click="menu = 'Слушатели'">
                <span>{{
                  $t("pages.profile.main.quick_access.buttons.listeners")
                }}</span>
              </div>

              <router-link class="qabtn border" to="/org/education-center-edit">
                <span>{{
                  $t("pages.profile.main.quick_access.buttons.change_profile")
                }}</span>
              </router-link>
            </div>
          </div>

          <div class="MyCourses">
            <span class="MCTitle">{{
              $t("pages.profile.main.courses.title")
            }}</span>

            <table class="course-table">
              <thead>
                <tr>
                  <th>{{ $t("pages.profile.main.courses.table.name") }}</th>
                  <th class="HideOnMobile">
                    {{ $t("pages.profile.main.courses.table.status") }}
                  </th>
                  <th class="HideOnMobile">
                    {{ $t("pages.profile.main.courses.table.start") }}
                  </th>
                  <th>{{ $t("pages.profile.main.courses.table.actions") }}</th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="(course, cindx) in this.courses"
                  :key="`course-${cindx}-${course.id}-${course.name}`"
                >
                  <td class="CourseName">
                    <span :lang="curLang">{{ course.name }}</span>
                  </td>

                  <td class="HideOnMobile">
                    <div
                      :class="{
                        msg: true,
                        wait:
                          statuses[
                            course.Project_Job_Statuses[
                              course.Project_Job_Statuses.length - 1
                            ].status
                          ] === 'waiting',
                        warn:
                          statuses[
                            course.Project_Job_Statuses[
                              course.Project_Job_Statuses.length - 1
                            ].status
                          ] === 'fail',
                        active:
                          statuses[
                            course.Project_Job_Statuses[
                              course.Project_Job_Statuses.length - 1
                            ].status
                          ] === 'active',
                      }"
                    >
                      <span>
                        {{
                          $t(
                            coursesStatusesText[
                              course.Project_Job_Statuses[
                                course.Project_Job_Statuses.length - 1
                              ].status
                            ]
                          )
                        }}
                      </span>

                      <img
                        v-if="
                          statuses[
                            course.Project_Job_Statuses[
                              course.Project_Job_Statuses.length - 1
                            ].status
                          ] === 'fail'
                        "
                        src="./../../assets/img/ReDesign/interface_icons/moderation_fail_16px.svg"
                        alt=""
                      />

                      <div class="DeclineMSG">
                        <span>{{
                          course.Project_Job_Statuses[
                            course.Project_Job_Statuses.length - 1
                          ].comment
                        }}</span>
                      </div>
                    </div>
                  </td>

                  <td class="HideOnMobile">
                    <a href="#" class="start-date">02.09.2025</a>
                  </td>

                  <td class="actions">
                    <router-link
                      class="actionBtn"
                      :to="`/org/course-add?courseID=${course.id}`"
                    >
                      <img
                        src="./../../assets/img/ReDesign/interface_icons/Change.svg"
                        alt=""
                      />
                    </router-link>

                    <div 
                      class="actionBtn"
                      @click="switchIsVisible(course)"
                    >
                      <img
                        v-show="course.isVisible"
                        src="./../../assets/img/ReDesign/interface_icons/View.svg"
                        alt=""
                      />
                      <img
                        v-show="!course.isVisible"
                        src="./../../assets/img/ReDesign/interface_icons/ViewNo.svg"
                        alt=""
                      />
                    </div>

                    <div
                      class="actionBtn"
                      @click="removeJobFromList(course.id)"
                    >
                      <img
                        src="./../../assets/img/ReDesign/interface_icons/Delete.svg"
                        alt=""
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>

        <template v-else>
          <div class="Steps">
            <span class="StepTitle">{{
              $t("pages.profile.main.not_moderation.title")
            }}</span>

            <div class="CardsStep">
              <div class="SCard">
                <div class="SText">
                  <template v-if="moderation.state === 'empty'">
                    <span class="STitle">{{
                      $t("pages.profile.main.not_moderation.empty.title")
                    }}</span>
                    <span class="SDesc">{{
                      $t("pages.profile.main.not_moderation.empty.desc")
                    }}</span>
                  </template>

                  <template v-if="moderation.state === 'waiting'">
                    <div class="STitle">
                      <div class="StatusIMG wait">
                        <img
                          src="./../../assets/img/ReDesign/interface_icons/moderation_wait_my.svg"
                          alt=""
                        />
                      </div>

                      <span>{{
                        $t("pages.profile.main.not_moderation.waiting.title")
                      }}</span>
                    </div>
                    <span class="SDesc"
                      >{{
                        $t("pages.profile.main.not_moderation.waiting.desc[0]")
                      }}
                      <br /><br />
                      {{
                        $t("pages.profile.main.not_moderation.waiting.desc[1]")
                      }}</span
                    >
                  </template>

                  <template v-if="moderation.state === 'fail'">
                    <div class="STitle">
                      <div class="StatusIMG fail">
                        <img
                          src="./../../assets/img/ReDesign/interface_icons/moderation_fail_my.svg"
                          alt=""
                        />
                      </div>

                      <span>{{
                        $t("pages.profile.main.not_moderation.fail.title")
                      }}</span>
                    </div>
                    <span class="SDesc">{{
                      $t("pages.profile.main.not_moderation.fail.desc")
                    }}</span>
                  </template>

                  <template v-if="moderation.state === 'active'">
                    <div class="STitle">
                      <div class="StatusIMG active">
                        <img
                          src="./../../assets/img/ReDesign/interface_icons/moderation_success_my.svg"
                          alt=""
                        />
                      </div>

                      <span>{{
                        $t("pages.profile.main.not_moderation.active.title")
                      }}</span>
                    </div>
                    <span class="SDesc">{{
                      $t("pages.profile.main.not_moderation.active.desc")
                    }}</span>
                  </template>
                </div>

                <span
                  v-if="
                    moderation.state === 'empty' || moderation.state === 'fail'
                  "
                  class="btn active noselect"
                  @click="stepButtonFillProfile"
                  >{{
                    $t(
                      moderation.state === "empty"
                        ? "pages.profile.main.not_moderation.buttons.fill_profile"
                        : "pages.profile.main.not_moderation.buttons.view_reasons"
                    )
                  }}</span
                >
              </div>

              <div class="SCard">
                <div class="SText">
                  <span class="STitle">{{
                    $t("pages.profile.main.not_moderation.second_step.title")
                  }}</span>
                  <span class="SDesc">{{
                    $t("pages.profile.main.not_moderation.second_step.desc")
                  }}</span>
                </div>

                <component
                  :class="{
                    btn: true,
                    noselect: true,
                    active: moderation.state === 'active',
                  }"
                  :is="moderation.state === 'active' ? 'RouterLink' : 'span'"
                  v-bind="
                    moderation.state === 'active'
                      ? { to: '/org/course-add' }
                      : {}
                  "
                  >{{
                    $t(
                      "pages.profile.main.not_moderation.buttons.create_course"
                    )
                  }}</component
                >
              </div>
            </div>
          </div>
        </template>
      </template>

      <template v-if="menu === 'Курсы'">
        <CoursesList />
      </template>

      <template v-if="menu === 'Слушатели'">
        <RequestsList />
      </template>

      <template v-if="menu === 'Настройки'">
        <Settings />
      </template>
    </div>

    <el-dialog
      v-model="SeenAchievements"
      custom-class="DEFAULT_ORG_VIEW_WELCOME"
      :before-close="checkNewAchievement"
    >
      <div class="DEFAULT_ORG_VIEW_BODY">
        <div
          class="DEFAULT_ORG_VIEW_WELCOME_STATUS DEFAULT_ORG_VIEW_WELCOME_STATUS_SUCCESS"
        ></div>

        <span class="DEFAULT_ORG_VIEW_WELCOME_TITLE">{{
          $t(NewAchievementTitle)
        }}</span>

        <span class="DEFAULT_ORG_VIEW_WELCOME_DESC">{{
          $t(NewAchievementDesc)
        }}</span>
      </div>
    </el-dialog>

    <el-dialog
      v-model="moderation.showReason"
      custom-class="DEFAULT_ORG_VIEW_WELCOME"
    >
      <div class="DEFAULT_ORG_VIEW_BODY">
        <div
          class="DEFAULT_ORG_VIEW_WELCOME_STATUS DEFAULT_ORG_VIEW_WELCOME_STATUS_FAIL"
        ></div>

        <span class="DEFAULT_ORG_VIEW_WELCOME_TITLE">{{
          $t("pages.profile.main.not_moderation.fail.title")
        }}</span>

        <span class="DEFAULT_ORG_VIEW_WELCOME_DESC">{{ moderation.msg }}</span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { transformUrl } from "@/utils/transformUrl.js";

import Settings from "@/components/Organization/Settings";
import RequestsList from "@/components/Organization/RequestsList";
import CoursesList from "@/components/Organization/CoursesList";

import { mapGetters, mapMutations } from "vuex";
import { findCompanyById } from "@/api/company.js";
import { findById } from "@/api/user.js";
import { refresh } from "@/api/auth.js";
import { findByAuthorId } from "@/api/n_project.js";
import { removeJob, updateJobIsVisible } from "@/api/job.js";
import {
  findByUserAchievements,
  seenAchievement,
  setAchievementToUser,
} from "@/api/achievements.js";

export default {
  components: {
    Settings,
    RequestsList,
    CoursesList
  },
  data() {
    return {
      menus: [
        {
          name: "Главная",
          translate: "pages.profile.menus.main",
        },
        {
          name: "Курсы",
          translate: "pages.profile.menus.courses",
        },
        {
          name: "Слушатели",
          translate: "pages.profile.menus.listeners",
        },
        {
          name: "Профиль",
          translate: "pages.profile.menus.profile",
        },
        {
          name: "Настройки",
          translate: "pages.profile.menus.settings",
        },
      ],
      menu: "Главная",

      company_name: "",
      moderation: {
        state: "empty", //empty; waiting; fail; active;
        msg: null,
        showReason: false,
      },

      companyProject: null,
      courses: [],

      coursesStatusesText: {
        Ожидает: "tables.statuses.awaiting",
        Одобрено: "tables.statuses.approved",
        Отклонено: "tables.statuses.rejected",
      },
      statuses: {
        Ожидает: "waiting",
        Одобрено: "active",
        Отклонено: "fail",
      },

      UserAchievements: [],
      SeenAchievements: false,
      NewAchievementID: null,
      NewAchievementTitle: "",
      NewAchievementDesc: "",
      NewAchievementsList: [],

      isloading: true,
    };
  },
  mounted() {
    // Получаем параметр menu из ссылки
    this.menu = this.$route.query.menu ? this.$route.query.menu : this.menu;
  },
  watch: {
    // Следим за изменениями route (если пользователь через NavbarMenu переключает)
    $route(to) {
      this.menu = this.$route.query.menu ? this.$route.query.menu : this.menu;
    },
  },
  computed: {
    ...mapGetters({
      user: "auth/isLoggedIn",
    }),
    backgroundAvatarStyle() {
      if (this.companyProject?.avatar_url) {
        return {
          background: `url('${this.transformLink(this.companyProject.avatar_url)}')`,
          backgroundSize: 'contain'
        };
      }
      return {};
    },
    getAvatarSymbols() {
      // Убираем лишние пробелы по краям и разбиваем строку на слова
      let words = this.company_name.trim().split(/\s+/);

      // Если слов больше одного – берем первые буквы первых двух слов
      if (words.length > 1) {
        return words[0].charAt(0) + words[1].charAt(0);
      }

      // Если только одно слово – берем первые два символа (или меньше, если слово короткое)
      return words[0].substring(0, 2);
    },

    curLang() {
      return this.$i18n.locale;
    },
  },
  async created() {
    if (this.user == null) {
      this.updateUser();
    } else {
      this.getUser(this.user.id);
    }

    try {
      let data = await findCompanyById(this.user.parent_company[0]?.id);
      this.company_name = data.data.name;
    } catch (e) {
      console.log(e);
    }

    await this.getCourses();

    await setAchievementToUser({
      user_id: this.user.id,
      codename: "org_has_first_course",
      _seen: false,
    });

    let _user_achievements_resp = await findByUserAchievements(this?.user?.id);
    this.UserAchievements = _user_achievements_resp.data;
    this.NewAchievementsList = this.UserAchievements.filter(
      (x) => x.seen === false && x.codename === "org_has_first_course"
    );

    await this.checkNewAchievement();
  },
  methods: {
    transformLink(url) {
      return transformUrl(url);
    },

    switchIsVisible(course) {
      course.isVisible = !course.isVisible;
      updateJobIsVisible(course.id, { isVisible: course.isVisible });
    },

    ...mapMutations("auth", ["SET_USER"]),
    async updateUser() {
      const response = await refresh();
      const userResponse = response.user;
      this.getUser(userResponse.id);
    },
    getUser(id) {
      if (id != undefined) {
        findById(id).then((response) => {
          this.SET_USER(response.data);
        });
      }
    },

    async getCourses() {
      try {
        let getCompanyCoursesRaw = await findByAuthorId(this.user.id);
        let companyWithCourses = getCompanyCoursesRaw.data;

        this.companyProject = companyWithCourses[0];
        this.courses = companyWithCourses[0].Jobs;

        this.setProfileStatus();
      } catch (e) {}
    },
    stepButtonFillProfile() {
      if (this.moderation.state === "fail") {
        this.moderation.showReason = true;
        return;
      }

      this.$router.push("/org/education-center-edit");
    },
    setProfileStatus() {
      if (
        this.companyProject?.Project_Job_Statuses == null ||
        this.companyProject.Project_Job_Statuses.length === 0
      ) {
        this.isloading = false;
        return;
      }

      const maxIdObject = this.companyProject.Project_Job_Statuses.reduce(
        (max, obj) => (obj.id > max.id ? obj : max),
        this.companyProject.Project_Job_Statuses[0]
      );

      this.moderation = {
        state: this.statuses[maxIdObject.status],
        msg: maxIdObject.comment,
      };

      this.isloading = false;
    },

    async removeJobFromList(jobid) {
      await removeJob([jobid]);
      await this.getCourses();
    },

    async checkNewAchievement() {
      if (this.NewAchievementID != null) {
        await seenAchievement(this?.user?.id, this.NewAchievementID);
      }

      if (
        this.NewAchievementsList != null &&
        this.NewAchievementsList.length != 0
      ) {
        let shifted = this.NewAchievementsList.shift();
        this.NewAchievementID = shifted.id;
        this.NewAchievementTitle = shifted.name;
        this.NewAchievementDesc = shifted.description;
        this.SeenAchievements = true;
      } else {
        this.SeenAchievements = false;
      }
    },
  },
};
</script>

<style scoped>
.StatusIMG > img {
  position: relative;
  margin: auto;
  width: 24px;
}
.StatusIMG {
  position: relative;
  display: flex;

  width: 48px;
  height: 48px;

  border-radius: 8px;

  overflow: hidden;
  flex-shrink: 0;
}
.StatusIMG.wait {
  background-color: #fff0c3;
}
.StatusIMG.fail {
  background-color: #ffe8e9;
}
.StatusIMG.active {
  background-color: #e4ffea;
}

.msg > * {
  margin: auto 0%;
}
.msg {
  position: relative;
  display: flex;

  padding: 4px 8px;

  width: fit-content;
  height: fit-content;

  flex-direction: row;
  justify-content: flex-start;
  gap: 4px;

  font-family: "Involve";
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0%;

  border-radius: 4px;
}
.msg.wait {
  color: #876500;
  background-color: #fff0c3;
}
.msg.warn {
  color: #dc3545;
  background-color: #ffe8e9;
}
.msg.active {
  color: #28a745;
  background-color: #e4ffea;
}

.container {
  width: 100%;
  max-width: 1168px; /* 1128px content + 20px padding on each side */
  margin-left: auto;
  margin-right: auto;
  padding-left: 20px;
  padding-right: 20px;
}

.Profile {
  position: relative;
  display: flex;

  width: 100%;

  height: fit-content;

  flex-direction: row;
  justify-content: flex-start;
  gap: 24px;

  overflow: visible;
}
.Navigation {
  position: relative;
  display: flex;

  width: 264px;
  height: fit-content;

  flex-direction: column;
  justify-content: flex-start;
  gap: 16px;

  flex-shrink: 0;
}
.UserInfo > * {
  margin: auto 0%;
}
.UserInfo {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: row;
  justify-content: flex-start;
  gap: 8px;
}
.Avatar {
  position: relative;
  display: flex;

  width: 56px;
  height: auto;

  aspect-ratio: 1 / 1;

  border-radius: 100%;

  flex-shrink: 0;

  background-color: #fd616133;

  overflow: hidden;

  flex-shrink: 0;
}
.AvatarName {
  position: relative;
  display: inline;

  margin: auto;

  width: fit-content;
  height: fit-content;

  font-family: "Involve";
  font-weight: 500;
  font-size: 24px;
  line-height: 248%;
  letter-spacing: 0%;
  text-transform: uppercase;

  color: #fd6161;
}

.ProfileName {
  position: relative;

  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;

  width: fit-content;
  height: fit-content;

  font-family: "Involve";
  font-weight: 500;
  font-size: 20px;
  line-height: 130%;
  letter-spacing: 0%;
  vertical-align: bottom;

  color: #1a1a1a;

  flex-shrink: 1;

  word-break: break-all;
  word-wrap: normal;
}

.Nav {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  justify-content: flex-start;
  gap: 4px;
}
.NavItem > * {
  margin: auto 0%;
}
.NavItem {
  position: relative;
  display: flex;

  cursor: pointer;

  padding: 7px 12px;

  width: 100%;
  height: fit-content;

  flex-direction: row;
  justify-content: space-between;

  background-color: transparent;
  transition: 0.3s;

  font-family: "Involve";
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0%;
  text-align: center;
  text-decoration: none;

  color: #1a1a1a;

  border-radius: 8px;
  word-break: break-word;
}

.NavItem.Active {
  background-color: #f8f8f8;
}

.ViewArea {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  justify-content: flex-start;
  gap: 40px;

  flex-shrink: 1;
  flex-grow: 0;
  flex-basis: auto;
  overflow: visible;
}
.InfoBlock {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  justify-content: flex-start;
  gap: 16px;
}
.Welcome {
  position: relative;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;

  width: fit-content;
  max-width: 100%;

  height: fit-content;

  font-family: "Involve";
  font-weight: 600;
  font-size: 32px;
  line-height: 130%;
  letter-spacing: 0%;
  vertical-align: middle;

  word-wrap: break-word;

  color: #1a1a1a;
}
.Desc {
  position: relative;
  display: inline;

  width: 100%;
  max-width: 534px;

  height: fit-content;

  font-family: "Involve";
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0%;
  vertical-align: middle;

  color: #666666;
}
.Steps {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  justify-content: flex-start;
  gap: 16px;
}
.StepTitle {
  position: relative;
  display: inline;

  width: fit-content;
  max-width: 100%;

  height: fit-content;

  font-family: "Involve";
  font-weight: 500;
  font-size: 24px;
  line-height: 130%;
  letter-spacing: 0%;
  vertical-align: middle;

  color: #1a1a1a;
}

.CardsStep {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  justify-content: flex-start;
  gap: 16px;
}

.SCard {
  position: relative;
  display: flex;

  padding: 24px;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  justify-content: flex-start;
  gap: 24px;

  border-radius: 16px;

  background-color: white;
  box-shadow: 0px 16px 32px -4px #0c0c0d0a;
}
.SText {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  justify-content: flex-start;
  gap: 16px;
}
.STitle > * {
  margin: auto 0%;
}
.STitle {
  position: relative;
  display: flex;

  width: fit-content;
  max-width: 100%;

  height: fit-content;

  flex-direction: row;
  justify-content: flex-start;
  gap: 10px;

  font-family: "Involve";
  font-weight: 500;
  font-size: 20px;
  line-height: 130%;
  letter-spacing: 0%;
  vertical-align: middle;

  color: #1a1a1a;
}
.SDesc {
  position: relative;
  display: inline;

  width: fit-content;
  max-width: 100%;

  height: fit-content;

  font-family: "Involve";
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0%;
  vertical-align: middle;

  color: #666666;
}

.btn {
  position: relative;
  display: flex;

  padding: 12px 20px;

  width: fit-content;
  height: fit-content;

  font-family: "Involve";
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0%;
  text-align: center;
  text-decoration: none;

  color: #898989;

  background-color: #e0e0e0;

  border-radius: 8px;

  transition: 0.3s;
}

.btn.active {
  background-color: #f9d773e5;
  color: #1a1a1a;
  cursor: pointer;
}

.DeclineMSG {
  position: absolute;
  display: none;

  bottom: -4px;
  left: 0;

  padding: 4px 8px;

  width: fit-content;
  max-width: 280px;

  height: fit-content;

  font-family: "Involve";
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0%;

  color: #dc3545;

  background-color: #ffe8e9;

  border-radius: 4px;

  transition: 0.3s;
  opacity: 0;

  transform: translateY(100%);
  z-index: 2;
  word-break: break-word;
}

.msg.warn:hover > .DeclineMSG {
  display: flex;
  opacity: 1;
}

.QuickActions,
.MyCourses {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  justify-content: flex-start;
  gap: 16px;
}
.QATitle,
.MCTitle {
  position: relative;
  display: inline;

  width: fit-content;
  max-width: 100%;

  height: fit-content;

  font-family: Involve;
  font-weight: 500;
  font-size: 24px;
  line-height: 130%;
  letter-spacing: 0%;

  color: #1a1a1a;
}
.QAButtons {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: row;
  justify-content: flex-start;
  gap: 8px;
}
.qabtn > * {
  margin: auto 0%;
}
.qabtn {
  position: relative;
  display: flex;

  cursor: pointer;

  padding: 12px 20px;

  width: fit-content;
  height: fit-content;

  flex-direction: row;
  justify-content: flex-start;
  gap: 8px;

  font-family: "Involve";
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0%;
  text-align: center;
  text-decoration: none;

  color: #1a1a1a;

  border-radius: 8px;
  word-break: break-word;
}
.qabtn.bg {
  background-color: #f9d773e5;
}
.qabtn.border {
  border: 1px solid #f9d773;
}
</style>

<style scoped>
.course-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0px 16px 32px -4px #0c0c0d0a;
}

.course-table th {
  font-family: "Involve";
  font-weight: 700;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0%;
  vertical-align: middle;
  word-break: break-word;
}

.course-table th {
  padding: 18px 24px;
  text-align: left;
  font-size: 14px;
}
.course-table td {
  padding: 4px 24px;
  text-align: left;
  font-size: 14px;
}

.course-table thead {
  background: #f8f8f8;
  font-weight: bold;
  border-bottom: 1px solid #e0e0e0;
}
.course-table td {
  font-family: "Involve";
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0%;

  color: #1a1a1a;
}

.status {
  padding: 4px 8px;
  border-radius: 4px;

  font-family: "Involve";
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0%;
  vertical-align: middle;
}

.status.moderation {
  background: #fff0c3;
  color: #876500;
}

.start-date {
  color: #666666;
  text-decoration: none;
  border-bottom: 1px solid #ccc;
}

.actions {
  display: flex;
  gap: 10px;
}

.actions button {
  width: 18px;
  height: 18px;
  border: none;
  background: transparent;
  cursor: pointer;
}

.actions .actionBtn {
  position: relative;
  display: flex;

  cursor: pointer;

  width: 40px;
  height: 40px;
}
.actions .actionBtn > img {
  position: relative;
  width: 16px;
  margin: auto;
}

.course-table thead > tr,
.course-table tbody > tr {
  position: relative;
  display: grid;
  grid-template-columns: 3fr repeat(3, minmax(0px, 1fr));
}
.course-table tbody > tr > td {
  margin: auto 0%;
}

.CourseName {
  max-width: 300px;
}

.CourseName > span {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  word-break: break-word;
}
</style>

<style scoped>
@media (max-width: 480px) {
}
@media (min-width: 480px) and (max-width: 768px) {
}
@media (min-width: 768px) and (max-width: 992px) {
}
@media (min-width: 992px) and (max-width: 1200px) {
}

@media (max-width: 993px) {
  .Navigation {
    display: none;
  }
}

@media (max-width: 768px) {
  .QAButtons > * {
    width: 100%;
  }
  .QAButtons {
    flex-direction: column;
    justify-content: flex-start;
  }

  .qabtn.bg > span {
    margin-right: auto;
  }
  .qabtn.bg > img {
    margin-left: auto;
  }
  .qabtn.border > span {
    margin: 0% auto;
  }

  .course-table thead > tr,
  .course-table tbody > tr {
    grid-template-columns: minmax(0px, 1fr) 132px;
  }

  .HideOnMobile {
    display: none;
  }

  .course-table .actions {
    gap: 4px;
    padding: 4px 0px 4px 4px;
  }

  .course-table .CourseName {
    padding: 4px 0px 4px 16px;
  }

  .course-table th {
    padding: 18px 16px;
  }

  .CourseName {
    overflow-wrap: break-word;
  }

  .course-table {
    overflow: hidden;
  }

  .Profile {
    padding-left: 16px;
    padding-right: 16px;
  }

  .ViewArea {
    width: 100%;
  }
}
</style>
